import React, { useState, useEffect } from 'react';
import FooterHome from '../Layouts/FooterHome';

const styles = {
  container: {
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  mainSection: {
    padding: '50px 20px',
    textAlign: 'center',
    backgroundColor: '#f9f9f9',
    flex: '1',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '90%',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#ffffff',
    padding: '20px',
  },
  button: {
    padding: '12px',
    backgroundColor: '#ff2300',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    marginTop: '20px',
    width: 'auto',
    whiteSpace: 'nowrap',
  },
  videoContainer: {
    marginTop: '20px',
    width: '80%',
    aspectRatio: '16/9',
    overflow: 'hidden',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
};

const translations = {
  es: {
    submit: 'Crea tu cuenta',
  },
  en: {
    submit: 'Create your account',
  },
};

function DemoPage() {
  // Initialize language from localStorage or fallback to 'es'
  const [language, setLanguage] = useState(
    () => localStorage.getItem('language') || 'es'
  );
  const t = translations[language];

  // Update localStorage when language changes
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  return (
    <div style={styles.container}>
      <main style={styles.mainSection}>
        <div style={styles.formContainer}>
          <div style={styles.videoContainer}>
            <iframe
              src="https://www.youtube-nocookie.com/embed/HRpqS9d2f74?si=KzYrUuMSwSsoE5Yu&controls=0"
              title="YouTube video player"
              style={styles.iframe}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <a href="/register" style={{ textDecoration: 'none' }}>
            <button style={styles.button}>{t.submit}</button>
          </a>
        </div>
      </main>
      <FooterHome language={language} setLanguage={setLanguage} />
    </div>
  );
}

export default DemoPage;
